var map = {
	"./admin_settings.png": 1756,
	"./appraisals.png": 1757,
	"./catalog.png": 1758,
	"./catalogWhite.png": 1759,
	"./catalog_orders.png": 1760,
	"./cms.png": 1761,
	"./component-fields/Asset.png": 1762,
	"./component-fields/Blocks.png": 1763,
	"./component-fields/Boolean.png": 1764,
	"./component-fields/Date-time.png": 1765,
	"./component-fields/LInk.png": 1766,
	"./component-fields/Markdown.png": 1767,
	"./component-fields/Multi asset.png": 1768,
	"./component-fields/Multi options.png": 1769,
	"./component-fields/Number.png": 1770,
	"./component-fields/Richtext.png": 1771,
	"./component-fields/Single options.png": 1772,
	"./component-fields/Table.png": 1773,
	"./component-fields/Text area.png": 1774,
	"./component-fields/Text.png": 1775,
	"./components.png": 1776,
	"./configuration.png": 1777,
	"./contents.png": 1778,
	"./crm.png": 1779,
	"./custom_order.png": 1780,
	"./customer_credits.png": 1781,
	"./customer_list.png": 1782,
	"./dashboard.png": 1783,
	"./finance.png": 1784,
	"./home.png": 1785,
	"./integrations.png": 1786,
	"./inventory-transfers.png": 1787,
	"./invoice-list.png": 1788,
	"./layaway.png": 1789,
	"./move.png": 1790,
	"./new_sale.png": 1791,
	"./orders.png": 1792,
	"./outgoing-consignments.png": 1793,
	"./payment-methods/amex.png": 1175,
	"./payment-methods/discover.png": 1174,
	"./payment-methods/mastercard.png": 1173,
	"./payment-methods/visa.png": 1172,
	"./payments.png": 1794,
	"./plus.png": 1378,
	"./register.png": 1795,
	"./repair_center.png": 1796,
	"./reports.png": 1797,
	"./services.png": 1798,
	"./trade_in_center.png": 1799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1629;